/* @flow */

import React from 'react';
import styled from 'styled-components';

import { getLabel } from '../../utils/i18n';
import { getSupportLocale } from '../../utils/locales';
import urlConfig from '../../config/urls';

const {
  external: { setEmailWhiteList: SET_EMAIL_WHITE_LIST_URL },
} = urlConfig;

const HelpBox = styled.div`
  width: 100%;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  > p {
    font-size: 14px;
    color: rgba(33, 40, 51, 1);
    line-height: 18px;
    margin-bottom: 12px;
  }
  ul {
    list-style-type: none;
  }
  li {
    font-size: 14px;
    color: rgba(132, 142, 156, 1);
    line-height: 18px;
    > a,
    a:visited {
      color: rgb(240, 185, 11);
    }
    a:hover {
      border-bottom: 1px solid rgb(240,185,11);
    }
  }
`;
type Props = {
  i18n: Object,
  locale: string,
};

const Help = ({ i18n, locale }: Props) => (
  <HelpBox>
    <p>{getLabel("exchange-register-haven'tReceivedEmail", i18n)}</p>
    <ul>
      <li>{getLabel('exchange-register-sureEmailCorrect', i18n)}</li>
      <li>{getLabel('exchange-register-checkSpam', i18n)}</li>
      <li>
        {getLabel('exchange-register-addEmailWhitelist', i18n)}{' '}
        <a
          href={SET_EMAIL_WHITE_LIST_URL.replace('%locale', getSupportLocale(locale))}
          target="_blank"
          rel="noopener noreferrer"
        >
          {getLabel('exchange-register-learnMore', i18n)}
        </a>
      </li>
      <li>{getLabel('exchange-register-makeEmailNormally', i18n)}</li>
    </ul>
  </HelpBox>
);

Help.defaultProps = {
  i18n: {},
  locale: 'en',
};

export default Help;
